import cn from "app/util/classnames";

interface HudButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
}

// Mock button used in gameplay HUD components
export default function HudButton(props: HudButtonProps) {
  return (
    <div
      tabIndex={-1}
      className={cn(
        "w-12 h-12 p-2 rounded-sm bg-black",
        "flex justify-center items-center",
        "text-white",
        "active:scale-95",
        "transition-transform duration-200",
        "hover:text-yellow",
        props.disabled
          ? "opacity-50 scale-90 cursor-auto"
          : "opacity-100 scale-100 cursor-pointer",
        props.className,
      )}
      onMouseDown={(e) => e.preventDefault()}
      onClick={props.disabled ? undefined : props.onClick}
    >
      {props.children}
    </div>
  );
}
